module.exports = __webpack_public_path__ + "img/set-priority.5ef5bbe7.svg";